
/**
 *Created by jmmartinez on 19/10/22
 *
 *
 * v.1.1 27/06/2023 Creadas funciones getFormattedDateFromPeriodo, numeroDiasPeriodo, corregirPeriodoPorDuracionMaxima
 */

import moment from "moment/moment";
import {stringWithZerosIzq} from "./StringUtils";
import {getDateFromNowSinHora, getDiasEntreDates, getDiasEntreTimestamp, getFormattedDateFromTimestamp, getDateFromTimestamp,
        addDias, siguienteDomingo, anteriorLunes} from "./DateUtils";



export const getPeriodoMesActual= () => {
    var hoy= getDateFromNowSinHora(); //new Date();
    var desde = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    var hasta = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);
    return {desde: desde, hasta: hasta};
}

export const getPeriodoAgnoActual= () => {
    var hoy= getDateFromNowSinHora(); //new Date();
    var desde = new Date(hoy.getFullYear(), 0, 1);
    var hasta = new Date(hoy.getFullYear(), 12, 0);
    return {desde: desde, hasta: hasta};
}

export const getPeriodoAgnoActualTimestamp= () => {
    console.log ("getPeriodoAgnoActualTimestamp: ");
    var hoy= getDateFromNowSinHora(); //new Date();
    var desde = new Date(hoy.getFullYear(), 0, 1);
    var hasta = new Date(hoy.getFullYear(), 12, 0);
    return {desde: desde.getTime(), hasta: hasta.getTime()};
}

export const getPeriodoMes= (mes) => {
    var hoy= getDateFromNowSinHora(); //new Date();
    var desde = new Date(hoy.getFullYear(), mes-1, 1);
    var hasta = new Date(hoy.getFullYear(), mes, 0);
    return {desde: desde, hasta: hasta};

}

export const getPeriodoTrimestre= (trimestre) => {
    var hoy= getDateFromNowSinHora(); //new Date();
    var mesInicio= ((trimestre -1 ) * 3);
    var mesFin= trimestre * 3;
    var desde = new Date(hoy.getFullYear(), mesInicio, 1);
    var hasta = new Date(hoy.getFullYear(), mesFin, 0);
    return {desde: desde, hasta: hasta};

}


export const getPeriodoUltimaSemana= () => {
    var hoy= getDateFromNowSinHora(); //new Date();
    var haceUnaSemana = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - 7);
    //var haceUnaSemana2= new Date(hoy.getTime() - 7 * 24 * 60 * 60 * 1000);
    return {desde: haceUnaSemana, hasta: hoy};
}

export const getPeriodoDiaActual= () => {
    var hoy= getDateFromNowSinHora(); //new Date();
    return {desde: hoy, hasta: hoy};
}

export const getPeriodoDiaActualTimestamp= () => {
    console.log("getPeriodoDiaActualTimestamp: ");
    var hoy= getDateFromNowSinHora().getTime(); //new Date();
    console.log("hoy: ", hoy);
    return {desde: hoy, hasta: hoy};
}


export const getPeriodoUltimoMes= () => {
    var hoy= getDateFromNowSinHora(); //new Date();
    var haceUnMes = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - 30);
    //var haceUnaSemana2= new Date(hoy.getTime() - 7 * 24 * 60 * 60 * 1000);
    return {desde: haceUnMes, hasta: hoy};
}

export const getPeriodoAgnoEscolar= (trimestre) => {
    var hoy= getDateFromNowSinHora(); //new Date();
    var mesInicio= 9;
    var mesFin= 6;
    var desde = new Date(hoy.getFullYear(), mesInicio, 1);
    var hasta = new Date(hoy.getFullYear()+1, mesFin, 0);
    return {desde: desde, hasta: hasta};

}

export const getPeriodoUltimosDias= (dias) => {
    var hoy= getDateFromNowSinHora();
    var haceDias = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - dias);
    return {desde: haceDias, hasta: hoy};
}


export const getPeriodo15DiasCentrados= () => {
    var hoy= getDateFromNowSinHora(); //new Date();
    var hace15 = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - 15);
    var dentro15 = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + 15);
    return {desde: hace15, hasta: dentro15};
}

export const getPeriodoProximos15Dias= () => {
    var hoy= getDateFromNowSinHora();
    var dentro15 = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + 15);
    return {desde: hoy, hasta: dentro15};
}

export const getPeriodoUltimoAgno= () => {
    var hoy= getDateFromNowSinHora(); //new Date();
    var haceUnAgno = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - 360);
    return {desde: haceUnAgno, hasta: hoy};
}

export const getPeriodoUltimoAgnoTimestamp= () => {
    var hoy= getDateFromNowSinHora(); //new Date();
    var haceUnAgno = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - 360);
    return {desde: haceUnAgno.getTime(), hasta: hoy.getTime()};
}

/*
export const getPeriodoAgnoActual = () => {
    let value = Date.now().format("YYYY");
    var momentDesde= moment("01/01/" + value, "DD/MM/YYYY");
    var momentHasta= moment("31/12/" + value, "DD/MM/YYYY");
    return {desde: momentDesde, hasta: momentHasta};
}

export const getPeriodoMesActual = () => {
    let value = Date.now().format("YYYY");
    var momentDesde= moment("01/01/" + value, "DD/MM/YYYY");
    var momentHasta= moment("31/12/" + value, "DD/MM/YYYY");
    return {desde: momentDesde, hasta: momentHasta};
}

 */

export const getFormattedDateFromPeriodo= (periodo) => {
    return getFormattedDateFromTimestamp(periodo.desde) + " - " +
        getFormattedDateFromTimestamp(periodo.hasta);
}

export const numeroDiasPeriodo= (periodo) => {
    let numDias= getDiasEntreTimestamp(periodo.desde, periodo.hasta);
    return numDias;
}

export const corregirPeriodoPorDuracionMaxima= (periodoOriginal, diasDuracionMaxima) => {
    let numDias= numeroDiasPeriodo(periodoOriginal);
    if (diasDuracionMaxima && numDias > diasDuracionMaxima){
        let tmNewHasta= periodoOriginal.hasta;
        let dtNewHasta= new Date(tmNewHasta);
        let dtNewDesde= new Date(dtNewHasta.getFullYear(), dtNewHasta.getMonth(), dtNewHasta.getDate() - diasDuracionMaxima);
        let tmNewDesde= dtNewDesde.getTime();
        return {desde: tmNewDesde, hasta: tmNewHasta};
    }
    else
        return periodoOriginal;
}

export const corregirPeriodoPorDuracionMaximaYTiempoPosteriorPorSemanas= (periodoOriginal, diasDuracionMaxima, diasPosterior) => {
    //console.log("+++ corregirPeriodoPorDuracionMaximaYTiempoPosterior");
    //console.log("periodoOriginal: ", periodoOriginal);
    //console.log("diasDuracionMaxima: ", diasDuracionMaxima);
    //console.log("diasPosterior: ", diasPosterior);

    let numDias= numeroDiasPeriodo(periodoOriginal);
    //console.log("numDias: ", numDias);
    if (diasDuracionMaxima && numDias > diasDuracionMaxima){
        let dtNewHasta=  addDias(new Date(), diasPosterior);
        //console.log("dtNewHasta: ", dtNewHasta);
        let tmNewHasta=  dtNewHasta.getTime();
        let dtNewDesde= new Date(dtNewHasta.getFullYear(), dtNewHasta.getMonth(), dtNewHasta.getDate() - diasDuracionMaxima);
        //console.log("dtNewDesde: ", dtNewDesde);
        let tmNewDesde= dtNewDesde.getTime();


        let dtNewDesdeLunes= anteriorLunes(dtNewDesde);
        let dtNewHastaDomingo= siguienteDomingo(dtNewHasta);
        //console.log("dtNewHastaDomingo: ", dtNewHastaDomingo);
        return {desde: dtNewDesdeLunes.getTime(), hasta: dtNewHastaDomingo.getTime()};
    }
    else
        return periodoOriginal;
}


